<template>
  <div>
    <el-dialog
      title="确认要提交吗?"
      :visible="creatForm"
      width="600px"
      append-to-body
      @close="f_close"
      @open="openInit"
    >
      <div>
        <div
          v-if="highBidItems.length"
          class="direct-copy-high-bid-alert mb-4"
        >
          <i class="el-icon-warning direct-copy-high-bid-alert__icon"></i>
          <div>
            <p class="direct-copy-high-bid-alert__title">Facebook 高出价警示</p>
            <p>检测到 {{ highBidItems.length }} 个广告组的出价达到或超过 50 美元，高出价可能导致广告花费快速增加。</p>
            <p v-for="item in highBidItems.slice(0, 5)" :key="item.id || item.name">
              {{ item.name || '广告组' }}：${{ Number(item.amount).toFixed(2) }}
            </p>
            <p v-if="highBidItems.length > 5">另有 {{ highBidItems.length - 5 }} 个广告组</p>
          </div>
        </div>
        <el-form
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="是否立即上传到Facebook："
            prop="resource"
          >
            <el-switch
              v-model="is_upload"
              :active-value="true"
              :inactive-value="false"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="投放开始时间：">
            <el-date-picker
              style="width: 200px"
              v-model="scheduleStartTime"
              type="datetime"
              placeholder="请选择投放开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="f_close">取 消</el-button>
        <el-button
          type="primary"
          @click="sure"
          id="editCopyEvent"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment';
moment.locale('zh-cn');
import { directCopy } from '@/api/adManagement.js';
export default {
  props: {
    creatForm: {
      type: Boolean,
      default: false,
    },
    level: {
      type: String,
      default: 'campaign',
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    highBidItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      is_upload: true,
      scheduleStartTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() + 3600 * 1000 * 24 < Date.now();
        },
      },
    };
  },
  watch: {
    scheduleStartTime: {
      handler(currentDate, previousDate) {
        // console.log(currentDate, previousDate, 'currentDate, previousDate');
        if (currentDate && previousDate) {
          const isDateChanged = currentDate.split(' ')[0] !== previousDate.split(' ')[0];
          const isTimeChanged = currentDate.split(' ')[1] !== previousDate.split(' ')[1];
          if (isDateChanged && !isTimeChanged) {
            // console.log('日期发生改变');
            this.scheduleStartTime = `${this.scheduleStartTime.split(' ')[0]} 00:00:00`;
          } 
          // else if (isTimeChanged) {
            // console.log('时分秒发生改变');
          // }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    openInit() {
      this.is_upload = this.level == 'adset' ? true : false;
    },
    f_close() {
      this.scheduleStartTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
      this.is_upload = this.level == 'adset'?true:false;
      this.$emit('update:creatForm', false);
    },
    sure() {
      // console.log(this.params);
      this.$showLoading();
      directCopy({
        ...this.params,
        is_upload: this.is_upload,
        start_time: this.scheduleStartTime,
      }).then((res) => {
        // console.log(res);
        this.$hideLoading();
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '创建成功，稍后去草稿箱查看上传结果',
          });
          this.$emit('update:creatForm', false);
          this.$emit('copied');
        } else {
          this.showCopyFail(res && res.comment);
        }
      }).catch((err) => {
        this.$hideLoading();
        this.showCopyFail(err && (err.comment || err.message));
      });
    },
    showCopyFail(comment) {
      const text = String(comment || '复制失败');
      const escaped = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\n/g, '<br/>');
      return this.$alert(escaped, '复制失败', {
        confirmButtonText: '知道了',
        dangerouslyUseHTMLString: true,
        type: 'error',
        customClass: 'copy-fail-alert',
      }).catch(() => {});
    },
  },
};
</script>
<style lang="scss">
.copy-fail-alert {
  width: 560px;
  .el-message-box__message {
    max-height: 360px;
    overflow: auto;
    line-height: 1.6;
    word-break: break-all;
  }
}
</style>
